import React from "react";
import { Button, Modal } from "react-bootstrap";
import { withRouter, RouteComponentProps } from "react-router-dom";
import {
  CloaseUpgradePlanModalFn,
  closeUpgradePlanModal,
} from "../../../redux/reducers/UpgradePlan";

import { connect } from "react-redux";
import { DocuClipperPlan } from "../../../docuclipper/DocuclipperTypes";

type Props = {};

type ReduxProps = {
  isOpen: boolean;
  neededPlan: DocuClipperPlan;
  feature: string;

  closeUpgradePlanModal: CloaseUpgradePlanModalFn;
};

export const UpgradeModal: React.SFC<Props & ReduxProps & RouteComponentProps> = ({
  isOpen,
  closeUpgradePlanModal,
  neededPlan,
  feature,
  history,
}) => {
  const toggle = () => closeUpgradePlanModal();

  return (
    <Modal size="lg" show={isOpen} onHide={toggle}>
      <Modal.Header closeButton={true}>
        <Modal.Title>Upgrade plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {feature
            ? `${feature} requires the ${neededPlan} plan or higher.`
            : `This feature requires the ${neededPlan} plan or higher.`}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Not now
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            toggle();
            history.push("/account/changePlans");
          }}
        >
          See plans
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  neededPlan: state.UpgradePlan.neededPlan,
  feature: state.UpgradePlan.feature,
  isOpen: state.UpgradePlan.isOpen,
});

const mapDispatchToProps = {
  closeUpgradePlanModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(UpgradeModal)
);
